import { createAction } from 'redux-actions'
import axios from 'axios';

export const loginRequested = createAction('auth/LOGIN_REQUESTED')
export const loginSucceeded = createAction('auth/LOGIN_SUCCEEDED')
export const loginFailed = createAction('auth/LOGIN_FAILED')

export function login(params) {
  return (dispatch) => {
    dispatch(loginRequested);
    return axios.post('/api/auth/login', params)
    .then(response => dispatch(loginSucceeded(response.data)))
    .catch(error => dispatch(loginFailed(error)));
  }
}

export const logoutRequested = createAction('logout/GET_REQUESTED')
export const logoutSucceeded = createAction('logout/GET_SUCCEEDED')
export const logoutFailed = createAction('logout/GET_FAILED')

export function logout() {
  return (dispatch) => {
    dispatch(logoutRequested);
    return axios.get('/api/auth/logout')
    .then(response => dispatch(logoutSucceeded(response.data)))
    .catch(error => dispatch(logoutFailed(error)));
  };
}



// WEBPACK FOOTER //
// ./actions/auth.js